import { useMutation, useQueryClient } from '@tanstack/react-query'

import { apiClient } from '../../../apiClient'
import { USE_GET_PROGRAM_ONTOLOGY_KEY } from '../useGetCurrentProgramOntologyConfig'

type UseDeleteOntologyFeaturesParams = {
  featureId: string
  programId: string
}

export function useDeleteOntologyFeature() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ featureId, programId }: UseDeleteOntologyFeaturesParams) =>
      await apiClient.delete(`/int/v3/programs/${programId}/ontology/${featureId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [USE_GET_PROGRAM_ONTOLOGY_KEY] })
    },
  })
}
